import React from 'react';
import {GlobalInfo} from './context'
import {forceDiscordAuth, toggleAdmin} from "./discord";
import {GearFill, CardList, Cash, CartFill, WalletFill, PersonBadgeFill } from 'react-bootstrap-icons';
import {withTranslation} from 'react-i18next';

import {globalSettings} from './config'

import {BrowserRouter as Router, Route, Switch} from "react-router-dom";

import {Nav, Navbar, NavDropdown, NavItem} from "react-bootstrap";
import {LinkContainer} from "react-router-bootstrap";

import MaterialsPage from './MaterialsPage';
import TransactionLogPage from './LogPage'
import BalancePage from "./BalancePage";
import RecipesPage from "./RecipesPage";
import QueuePage from "./QueuePage";
import SkillsPage from "./SkillsPage";
import AlignPage from "./AlignPage";
import {FrontPage} from "./FrontPage";
import {EngineerOnly, FinanceOnly, If, TransactButton} from "./Common";
import {LanguageSwitcher} from "./LanguageSwitcher";
import {LogisticsPage} from "./LogisticsPage";
import {RequestsPage} from "./RequestsPage";
import {STATUS_QUEUED} from "./model/data";
import {AuditPage} from "./AuditPage";
import {TargetPage} from "./TargetPage";
import DiscordServersPage from "./DiscordServersPage";
import SyncPricesPage from "./SyncPricesPage";

function formatRoleString(roles, t) {
  if(roles.superuser) {
    return t('common:roles.superuser')
  } else if(roles.finance) {
    return t('common:roles.finance')
  } else if(roles.engineer) {
    return t('common:roles.engineer')
  } else {
    return t('common:roles.member')
  }
}

class App extends React.Component {
  render() {
    const { t } = this.props;
    return (
        <Router>

          <Navbar variant="dark" bg="dark" fixed="top" expand="lg" collapseOnSelect>
            <div className={"container"}>
              <LinkContainer to="/">
                <Navbar.Brand href="/">
                  <img src="/pandemic4.png" height="35"/>
                  &nbsp;
                </Navbar.Brand>
              </LinkContainer>
              <Navbar.Toggle/>
              <Navbar.Collapse>
                <Nav className={"mr-auto"}>
                  <LinkContainer to="/materials">
                    <NavItem>
                      <Nav.Link href="/materials">
                        <Cash /> {t('navigation:menu.buyback')}
                      </Nav.Link>
                    </NavItem>
                  </LinkContainer>
                  {this.context.roles.engineer || !globalSettings.hideRecipesUnlessAdmin ? <LinkContainer to="/recipes">
                    <NavItem>
                      <Nav.Link href="/recipes">
                        <CartFill /> {t('navigation:menu.order')}
                      </Nav.Link>
                    </NavItem>
                  </LinkContainer> : null}
                  {this.context.roles.engineer || !globalSettings.hideQueueUnlessAdmin ? <LinkContainer to="/queue">
                    <NavItem>
                      <Nav.Link href="/queue">
                        <GearFill /> {t('navigation:menu.queue')}
                        <EngineerOnly>
                          <If cond={this.context.queue.filter((queue) => queue.status === STATUS_QUEUED && queue.queue === "main").length}>
                            <span className="badge badge-primary ml-1">
                              {this.context.queue.filter((queue) => queue.status === STATUS_QUEUED && queue.queue === "main").length}
                            </span>
                          </If>
                        </EngineerOnly>
                      </Nav.Link>
                    </NavItem>
                  </LinkContainer> : null}
                  <LinkContainer to="/balance">
                    <NavItem>
                      <Nav.Link href="/balance">
                        <WalletFill/> {t('navigation:menu.balance')}
                      </Nav.Link>
                    </NavItem>
                  </LinkContainer>
                  <LinkContainer to="/skills">
                    <NavItem>
                      <Nav.Link href="/skills">
                        <PersonBadgeFill/> {t('navigation:menu.skills')}
                      </Nav.Link>
                    </NavItem>
                  </LinkContainer>
                  <LinkContainer to="/log">
                    <NavItem>
                      <Nav.Link href="/log">
                        <CardList /> {t('navigation:menu.log')}
                      </Nav.Link>
                    </NavItem>
                  </LinkContainer>
                  <FinanceOnly>
                    <NavDropdown title={t('navigation:menu.admin')} id="admin-menu">
                    <LinkContainer to="/requests">
                      <NavDropdown.Item>
                        <Nav.Link href="/requests">
                          {t('navigation:menu.requests')}
                          <If cond={this.context.requests.length}>
                            <span className="badge badge-primary ml-1">
                            {this.context.requests.length}
                            </span>
                          </If>
                        </Nav.Link>
                      </NavDropdown.Item>
                    </LinkContainer>
                      <LinkContainer to="/audit">
                      <NavDropdown.Item>
                        <Nav.Link href="/audit">{t('navigation:menu.audit')}</Nav.Link>
                      </NavDropdown.Item>
                     </LinkContainer>
                      <LinkContainer to="/target">
                      <NavDropdown.Item>
                        <Nav.Link href="/target">{t('navigation:menu.targets')}</Nav.Link>
                      </NavDropdown.Item>
                     </LinkContainer>
                      <LinkContainer to="/discord-servers">
                      <NavDropdown.Item>
                        <Nav.Link href="/discord-servers">{t('navigation:menu.discordServers')}</Nav.Link>
                      </NavDropdown.Item>
                     </LinkContainer>
                    </NavDropdown>
                  </FinanceOnly>
                  <NavDropdown title={t('navigation:menu.tools')} id="tools-menu">
                    <LinkContainer to="/tools/align"><NavDropdown.Item href={"/tools/align"}>{t('navigation:menu.alignTime')}</NavDropdown.Item></LinkContainer>
                    <FinanceOnly>
                      <LinkContainer to="/tools/sync-prices"><NavDropdown.Item href={"/tools/sync-prices"}>Sync Prices</NavDropdown.Item></LinkContainer>
                    </FinanceOnly>
                  </NavDropdown>
                </Nav>
                <Nav>
                  <EngineerOnly>
                    <div className={"form-inline"}>
                      <TransactButton user={this.context.userData} />
                    </div>
                  </EngineerOnly>
                  <LanguageSwitcher />
                  <NavDropdown title={this.context.userInfo.name} id="user-menu">
                    <NavDropdown.ItemText>{t('common:labels.role')}: {formatRoleString(this.context.roles, t)}</NavDropdown.ItemText>
                    <NavDropdown.Item onClick={forceDiscordAuth}>{t('common:buttons.logout')}</NavDropdown.Item>
                    {this.context.userInfo.actuallyAdmin ? <NavDropdown.Item onClick={toggleAdmin}>{t('common:buttons.toggleAdmin')}</NavDropdown.Item> : null}
                  </NavDropdown>
                </Nav>
              </Navbar.Collapse>
            </div>
          </Navbar>
          {/*<div className={"container"}>*/}
          {/*  <div className={"alert alert-warning"}>*/}
          {/*    🚧 🚧 🚧 <strong>NOTE:</strong> this is a <strong>prototype</strong> industry management system for the Pandemic corporation. I'm in the process*/}
          {/*    of preparing it for launch, so feel free to look around but do not log any real transactions here until further notice. 🚧 🚧 🚧*/}
          {/*  </div>*/}
          {/*</div>*/}
          <Switch>
            <Route path="/log">
              <TransactionLogPage/>
            </Route>
            <Route path="/balance">
              <BalancePage/>
            </Route>
            <Route path="/recipes">
              <RecipesPage/>
            </Route>
            <Route path="/queue">
              <QueuePage/>
            </Route>
            <Route path="/skills">
              <SkillsPage/>
            </Route>
            <Route path="/tools/align">
              <AlignPage/>
            </Route>
            <Route path="/tools/sync-prices">
              <SyncPricesPage/>
            </Route>
            <Route path="/materials">
              <MaterialsPage/>
            </Route>
            <Route path="/logistics">
              <LogisticsPage/>
            </Route>
            <Route path="/requests">
              <RequestsPage/>
            </Route>
                        <Route path="/audit">
              <AuditPage/>
            </Route>
                                    <Route path="/target">
              <TargetPage/>
            </Route>
            <Route path="/discord-servers">
              <DiscordServersPage/>
            </Route>
            <Route path="/">
              <FrontPage/>
            </Route>
          </Switch>
        </Router>
    );
  }
}

App.contextType = GlobalInfo;

export default withTranslation(['navigation', 'common'])(App);
